import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => {

  return (
    <SectionContainer
      id='delete-account-page'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row align='center'>
        <Col
          medium={10}
          large={8}>
          <Typography
            component='h1'
            nextElement='typography'
            align='center'>
            Delete Online Account
          </Typography>
          <Typography nextElement='button'>
            By following this process, you can request your account to be permanently deleted. The following data (full name, email, password, phone factor (SMS&#47;Voice) and authenticator app) will be deleted and the following types of data (financial and payment information, health data) will be retained for the purposes of conducting business, providing service and regulatory compliance. Our team <strong>will not</strong> be able to recover the account once you have permanently deleted it. This doesn&#39;t cancel or remove any product or investment account you currently have with Northwestern Mutual.
          </Typography>
        </Col>
        <Col align='center'>
          <Link
            id='online-privacy-statement-link'
            variant='buttonLinkPrimary'
            linkUrl='/online-privacy-statement/'>
            Online privacy statement
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );
};
